import React, { lazy } from 'react';

export const CHUNK_RELOAD_KEY = 'chunkReloadAttempted';

const readReloadFlag = () => {
    try {
        return sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';
    } catch {
        return true; // Без хранилища нечем ограничить перезагрузки: считаем попытку использованной
    }
};

const writeReloadFlag = () => {
    try {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
        return true;
    } catch {
        return false;
    }
};

export const clearChunkReloadFlag = () => {
    try {
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    } catch {
        // Хранилище недоступно: флага там нет
    }
};

export const isChunkLoadError = (error) => (
    error?.name === 'ChunkLoadError'
    || error?.code === 'CSS_CHUNK_LOAD_FAILED'
    || /Loading (CSS )?chunk .+ failed/i.test(String(error?.message || ''))
);

export const isOffline = () => typeof navigator !== 'undefined' && navigator.onLine === false;

const load = async (importer) => {
    let loaded;
    try {
        loaded = await importer();
    } catch (error) {
        // Без сети перезагрузка привела бы на страницу офлайна и не помогла бы
        if (isChunkLoadError(error) && !isOffline() && !readReloadFlag() && writeReloadFlag()) {
            // После выкладки старые файлы исчезают; свежий index.html укажет на новые
            window.location.reload();
            return new Promise(() => {});
        }
        throw error;
    }
    clearChunkReloadFlag();
    return loaded;
};

// React.lazy запоминает отказ навсегда, поэтому для повторной попытки нужен новый lazy-компонент
const failedRoutes = new Set();

export const resetFailedLazyRoutes = () => {
    failedRoutes.forEach((reset) => reset());
    failedRoutes.clear();
};

const lazyWithRetry = (importer) => {
    let Current;
    const reset = () => {
        Current = lazy(() => load(importer).catch((error) => {
            failedRoutes.add(reset);
            throw error;
        }));
    };
    reset();

    const LazyRoute = (props) => <Current {...props} />;
    return LazyRoute;
};

export default lazyWithRetry;
